import { PayPalButtons, PayPalScriptProvider, ReactPayPalScriptOptions } from '@paypal/react-paypal-js';
import { useTranslation } from 'react-i18next';
import { RestClient } from './api/RestClient';
import { useState } from 'react';

export interface PaypalButtonsProps {
  clientID: string;
  currency: string;
  packetID: string;
  orderID: string;
  confirmCode: string;
  buyerCountry?: string;
  back: () => void;
  showError: (msg?: string) => void;
}

function PaypalButtons({clientID, currency, packetID, orderID, confirmCode, buyerCountry, back, showError}: PaypalButtonsProps) {
  const { t, i18n } = useTranslation();

  const initialOptions: ReactPayPalScriptOptions = {
        clientId: clientID,
        buyerCountry: buyerCountry,
        currency: currency,
        "data-page-type": "product-details",
        components: "buttons",
        "data-sdk-integration-source": "developer-studio",
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
    <PayPalScriptProvider options={initialOptions}>
                <PayPalButtons
                   style={{
                        shape: "pill",
                        layout: "vertical",
                        color: "blue",
                        label: "pay",
                    }}
                   createOrder={async () => {
                        try {
                            showError();
                            const orderData = await RestClient.getInstance().confirmOrderPacket(packetID, orderID||'', confirmCode,i18n.language, true);

                            if (orderData && orderData.paypaloid) {
                                return orderData.paypaloid;
                            } else {
                                throw new Error('Error paypal order not received');
                            }
                        } catch (error) {
                            console.error(error);
                            const errorStr = error as string;
                            if (errorStr === 'errInvalidCode') {
                              console.log('Invalid code');
                                showError(t('errInvalidCode'));
                                throw new Error('errInvalidCode');
                            } else {
                              console.log('Paypal order creation error');
                                showError(t('paypalErrorMsg'));
                            }
                            return '';
                        }
                    }}

                   onApprove={async (data, actions) => {
                        try {
                            showError();
                            await RestClient.getInstance().capturePaypalOrder(data.orderID);
                            // Devo procedere
                            back();
                        } catch (error) {
                            console.error(error);
                            showError(t('paypalErrorMsg'));
                        }
                    }}

                  onCancel={async (data, actions) => {
                        try {
                            showError();
                          // Devo annullare la richiesta di pagamento dato che ormai l'ordine è stato creato
                          //cancel();
                          // Il backend se richiamato risponde con lo stesso ordine, vediamo come funziona.
                        } catch (error) {
                            console.error(error);
                            showError(t('paypalErrorMsg'));
                        }
                    }}
                  onError={async (err) => {
                        try {
                          // Devo annullare la richiesta di pagamento dato che ormai l'ordine è stato creato
                          console.log(err);
                          const errorStr = ((err as any) as Error)?.message;
                          if (errorStr === 'errInvalidCode') {
                            console.log('Invalid code');
                            showError(t('errInvalidCode'));
                          } else {
                            showError(t('paypalErrorMsg'));
                          }
                          //cancel();
                        } catch (error) {
                            console.error(error);
                            showError(t('paypalErrorMsg'));
                        }
                    }}
                />
            </PayPalScriptProvider>
          </div>
  );
}

export default PaypalButtons;
